/**
 * Lead Card Component
 * Displays lead entity information from MCP tool results
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import type { LeadEntity } from '@/api/types/mcp.types';
import './EntityCard.css';

interface LeadCardProps {
  lead: LeadEntity;
  compact?: boolean;
}

export const LeadCard: React.FC<LeadCardProps> = ({
  lead,
  compact = false,
}) => {
  const statusColors: Record<string, string> = {
    active: 'green',
    new: 'blue',
    qualified: 'purple',
    lost: 'red',
  };

  return (
    <div className={`lead-card entity-card ${compact ? 'compact' : ''}`}>
      <div className="entity-card-header">
        <h4 className="entity-card-title">{lead.name}</h4>
        {lead.status && (
          <Tag color={statusColors[lead.status] || 'default'}>
            {lead.status}
          </Tag>
        )}
      </div>

      {!compact && (
        <div className="entity-card-body">
          <div className="entity-card-field">
            <span className="field-label">ID:</span>
            <span className="field-value">{lead.id.substring(0, 8)}...</span>
          </div>
        </div>
      )}

      <div className="entity-card-footer">
        <Link to={`/apps/leads/${lead.id}`} className="entity-card-link">
          View Details →
        </Link>
      </div>
    </div>
  );
};
